import type { Room } from './pages/Rooms/useRooms/types';

const byPriceAscending = (a: Room, b: Room) =>
  (a.price?.amount ?? Infinity) - (b.price?.amount ?? Infinity);

export const selectAlternativeRooms = (rooms: Room[], currentRoomId: string): Room[] =>
  (Array.isArray(rooms) ? rooms : [])
    .filter((room) => room.id !== currentRoomId && !room.unAvailable)
    .sort(byPriceAscending);
